import { DomItem } from "./domItem"
import { ITimelineCtrl } from "./types"

export function isItemFiltered(tl: ITimelineCtrl, item: DomItem): boolean {

    if (!item.vm.visible) return true

    if (tl.isEditing()) {
        return !tl.selection.canSelectAsEditTarget(item.vm)
    }

    return false

}


export function canSelectItem(tl: ITimelineCtrl, item: DomItem) {

    if (!item.vm.visible) return false

    if (!tl.isEditing()) return true

    if (tl.selection.multiple) {
        return tl.selection.canSelectAsEditTarget(item.vm)
    }

    return false

}
